import { useEffect } from 'react';

/**
 * Это костыль для https://centrateam.atlassian.net/browse/CA-3126
 * надо как то пофиксить по другому
 *  - если мы накинем в общих стилях на html position 'relative', то некорректно работают тултипы везде!
 *  - без html position 'relative' некорректно работает фича с useViewPortMobileKeyboard
 *  */
export const useChangeHTMLPosition = (isHasInput?: boolean) => {
  useEffect(() => {
    if (isHasInput) {
      document.getElementsByTagName('html')[0].style.position = 'relative';
    }

    return () => {
      document.getElementsByTagName('html')[0].style.position = '';
    };
  }, [isHasInput]);
};
